import React from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';
import { Input, InputGroup, InputGroupAddon, FormGroup, FormFeedback } from 'reactstrap';
import RegexLibrary from '../../utils/Regex';

import HttpAuth from '../../services/http/Auth';

import StorageAuth from '../../services/storage/Auth';


import Notification from './../Elements/Notification';
import RoutePathLibrary from '../../utils/RoutePath';

class LoginForm extends React.Component<WithTranslation> {

  public state : { [key: string] : any} = {
    emailValue              : '',
    emailIsValid            : true,
    emailFeedbackMessage    : '',
    
    passwordValue           : '',
    passwordIsValid         : true,
    passwordFeedbackMessage : '',

    rememberMeValue         : true,
  };

  constructor(props: any) {
    super(props);
  }

  changeLanguage = (lng: string) => {
    this.props.i18n.changeLanguage(lng);
  }

  render() {
    return (
      <div>
        <div id="login-form">
          <h1 className="section-title">Post venta</h1>
          <div className="form-header">
            <span className="icon oi oi-person"></span>
          </div>
          <div id="form-container">
            <div className="col-md-12">
              <form onSubmit={this.handleSubmit}>
                <FormGroup>
                  <InputGroup className="mb-2">
                    <InputGroupAddon addonType="prepend"><span className="input-group-text oi oi-person"></span></InputGroupAddon>
                    <Input type="text" placeholder="E-mail" autoFocus={true} invalid={!this.state.emailIsValid} value={this.state.emailValue} onChange={this.handleChangeEmail} />
                    <FormFeedback>{ this.state.emailFeedbackMessage }</FormFeedback>
                  </InputGroup>
                </FormGroup>
                <FormGroup>
                  <InputGroup className="mb-2">
                    <InputGroupAddon addonType="prepend">@</InputGroupAddon>
                    <Input type="password" placeholder="Password" invalid={!this.state.passwordIsValid} value={this.state.passwordValue} onChange={this.handleChangePassword} />
                    <FormFeedback>{ this.state.passwordFeedbackMessage }</FormFeedback>
                  </InputGroup>
                </FormGroup>
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-8 remember-me-container">
                      <div className="checkbox c-checkbox">
                        <label>
                          <Input checked={this.state.rememberMeValue} onChange={this.handleChangeRememberMe} type="checkbox"/>
                          <span className="fa fa-check"></span>&nbsp;<Trans i18nKey="LoginForm-rememberMe" />
                        </label>
                      </div>
                    </div>
                    <div className="col submit-container">
                      <button type="submit" className="btn btn-primary mb-2"><Trans i18nKey="common-form-submit" /></button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* <div className="forgot-password-container">
            <a href="https://google.es" target="_blank" rel="noopener noreferrer"><Trans i18nKey="LoginForm-forgotMyPassword" /></a>
          </div> */}
        </div>
      </div>
    );
  }

  handleChangeEmail = (e: any) => {
    this.setState({ emailValue: e.target.value });
  };

  handleChangePassword = (e: any) => {
    this.setState({ passwordValue: e.target.value });
  };

  handleChangeRememberMe = (e: any) => {
    this.setState({ rememberMeValue: e.target.checked });
  }

  private validateEmail = () => {
    const stateKey        = 'email';
    const valueToValidate = this.state[`${stateKey}Value`];

    let isValid         = true;
    let feedbackMessage = '';

    if (!valueToValidate) {
      isValid         = false;
      feedbackMessage = this.props.t('common-field-cannotEmpty');
    } else if (!RegexLibrary.email.test(valueToValidate)) {
      isValid         = false;
      feedbackMessage = this.props.t('common-field-mustEmailFormat');
    }

    const stateToChange : { [key: string] : any } = {};
    stateToChange[`${stateKey}IsValid`]         = isValid;
    stateToChange[`${stateKey}FeedbackMessage`] = feedbackMessage;


    this.setState(stateToChange);

    return isValid;
  }

  private validatePassword = () => {
    const stateKey        = 'password';
    const valueToValidate = this.state[`${stateKey}Value`];

    let isValid         = true;
    let feedbackMessage = '';

    if (!valueToValidate) {
      isValid         = false;
      feedbackMessage = this.props.t('common-field-cannotEmpty');
    } else if (!RegexLibrary.password.test(valueToValidate)) {
      isValid         = false;
      feedbackMessage = this.props.t('common-field-passwordFormat');
    }

    const stateToChange : { [key: string] : any } = {};
    stateToChange[`${stateKey}IsValid`]         = isValid;
    stateToChange[`${stateKey}FeedbackMessage`] = feedbackMessage;


    this.setState(stateToChange);

    return isValid;
  }

  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!this.validateEmail() || !this.validatePassword()) {
      return;
    }

    let response;
    
    try {
      response = await new HttpAuth().login(this.state.emailValue, this.state.passwordValue);
    } catch (err) {
      Notification.displayException(err);
      return;
    }

    StorageAuth.saveSession(response.idToken, response.refreshToken, response.expiresIn, this.state.rememberMeValue);

    // TODO why history is not typed inside props?
    // @ts-ignore
    this.props.history.push(RoutePathLibrary.login);
  }

}

export default withTranslation()(LoginForm);
